var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-center-content"},[_c('div',{staticClass:"rb-popup-body",domProps:{"innerHTML":_vm._s(_vm.data.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }